import { render, staticRenderFns } from "./step-configure.vue?vue&type=template&id=05f0a782&scoped=true"
import script from "./step-configure.vue?vue&type=script&lang=js"
export * from "./step-configure.vue?vue&type=script&lang=js"
import style0 from "./step-configure.vue?vue&type=style&index=0&id=05f0a782&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f0a782",
  null
  
)

export default component.exports